import React from "react";

export function Alert({ children, className = "", ...props }) {
  return (
    <div
      className={`border-l-4 border-yellow-500 bg-yellow-50 p-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function AlertDescription({ children, className = "", ...props }) {
  return (
    <p className={`text-sm text-yellow-700 ${className}`} {...props}>
      {children}
    </p>
  );
}
